import { render } from "./MonitorRouteVehicle.vue?vue&type=template&id=2e510944"
import script from "./MonitorRouteVehicle.vue?vue&type=script&lang=js"
export * from "./MonitorRouteVehicle.vue?vue&type=script&lang=js"

import "./MonitorRouteVehicle.vue?vue&type=style&index=0&id=2e510944&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render

export default script